import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AppConsts } from '../../AppConsts';
import { ServiceTypeDto, ServiceTypeService } from 'src/app/proxy/service-types';

@Component({
  selector: 'app-service-type-selector',
  standalone: false,
  templateUrl: './service-type-selector.component.html',
})
export class ServiceTypeSelectorComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() serviceTypeIdSelected: number | undefined;
  @Input() isDisabled = false;

  @Output() changeSelectedServiceType = new EventEmitter<ServiceTypeDto>();
  serviceTypes: ServiceTypeDto[];
  selectedServiceType: ServiceTypeDto;

  constructor(
    injector: Injector,
    private readonly _serviceTypeService: ServiceTypeService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadServiceTypes();
    this.onSelected();
  }

  async loadServiceTypes(): Promise<void> {
    try {
      this.showLoading();

      const result = await firstValueFrom(this._serviceTypeService.getList({
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      }));

      this.serviceTypes = result.items;
    } finally {
      this.hideLoading();
    }
  }

  onSelected(): void {
    this.changeSelectedServiceType.emit(this.selectedServiceType);
  }

  async setSelectedServiceTypeById(serviceTypeId: number | undefined): Promise<void> {
    this.serviceTypeIdSelected = serviceTypeId;

    if (this.isNullOrUndefined(this.serviceTypes)) {
      await this.loadServiceTypes();
    }
    
    this.setSelectedServiceType();
  }

  private setSelectedServiceType(): void {
    if (this.serviceTypes?.length) {
      this.selectedServiceType = this.serviceTypes.find(x => x.id === this.serviceTypeIdSelected);
      this.onSelected();
    }
  }
}